/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */

/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */

// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript'
// @ts-ignore
// prettier-ignore
import type { RequestConfig, RequestFunctionRestArgs } from 'yapi-to-typescript'
// @ts-ignore
import request from '../../../request';

type UserRequestRestArgs = RequestFunctionRestArgs<typeof request>;

// Request: 目前 React Hooks 功能有用到
export type Request<
  TRequestData,
  TRequestConfig extends RequestConfig,
  TRequestResult
> = (TRequestConfig['requestDataOptional'] extends true
  ? (requestData?: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult
  : (requestData: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult) & {
  requestConfig: TRequestConfig;
};

const mockUrl_0_0_0_0 = 'http://10.50.16.213:40001/mock/295' as any;
const devUrl_0_0_0_0 = '' as any;
const prodUrl_0_0_0_0 = 'http://127.0.0.1' as any;
const dataKey_0_0_0_0 = 'retdata' as any;

/**
 * @分类 [mock表单模板管理↗](http://10.50.16.213:40001/project/295/interface/api/cat_2062)
 * @请求头 `GET /api/formTemplate/page`
 */
export interface FormTemplatePageGetRequest {
  /**
   * 名称，模糊查询
   */
  name?: string;
  /**
   * 名称或说明，模糊查询
   */
  nameOrDescription?: string;
  /**
   * 状态
   */
  status?: string;
  page?: string;
  size?: string;
}

/**
 * @分类 [mock表单模板管理↗](http://10.50.16.213:40001/project/295/interface/api/cat_2062)
 * @请求头 `GET /api/formTemplate/page`
 */
export interface FormTemplatePageGetResponse {
  /**
   * 当前页
   */
  page?: number;
  /**
   * 每页的数量
   */
  size?: number;
  /**
   * 总记录数
   */
  total?: number;
  /**
   * 结果集
   */
  list?: {
    /**
     * 主键
     */
    id?: number;
    /**
     * 名称
     */
    name?: string;
    /**
     * 说明
     */
    description?: string;
    /**
     * 状态。
     */
    status?: number;
    /**
     * 占位符个数
     */
    paramCount?: number;
    /**
     * 更新人名称
     */
    updateCropUserName?: string;
    /**
     * 更新时间
     */
    updateTime?: {
      /**
       * The number of seconds from the epoch of 1970-01-01T00:00:00Z.
       */
      seconds?: number;
      /**
       * The number of nanoseconds, later along the time-line, from the seconds field.
       * This is always positive, and never exceeds 999,999,999.
       */
      nanos?: number;
    };
  }[];
}

/**
 * @分类 [mock表单模板管理↗](http://10.50.16.213:40001/project/295/interface/api/cat_2062)
 * @请求头 `GET /api/formTemplate/page`
 */
type ApiFormTemplatePageGetRequestConfig = Readonly<
  RequestConfig<
    'http://10.50.16.213:40001/mock/295',
    '',
    'http://127.0.0.1',
    '/api/formTemplate/page',
    'retdata',
    string,
    'name' | 'nameOrDescription' | 'status' | 'page' | 'size',
    false
  >
>;

/**
 * @分类 [mock表单模板管理↗](http://10.50.16.213:40001/project/295/interface/api/cat_2062)
 * @请求头 `GET /api/formTemplate/page`
 */
const apiFormTemplatePageGetRequestConfig: ApiFormTemplatePageGetRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/api/formTemplate/page',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: ['name', 'nameOrDescription', 'status', 'page', 'size'],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'apiFormTemplatePageGet',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * @分类 [mock表单模板管理↗](http://10.50.16.213:40001/project/295/interface/api/cat_2062)
 * @请求头 `GET /api/formTemplate/page`
 */
export const apiFormTemplatePageGet = /*#__PURE__*/ (
  requestData: FormTemplatePageGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<FormTemplatePageGetResponse>(prepare(apiFormTemplatePageGetRequestConfig, requestData), ...args);
};

apiFormTemplatePageGet.requestConfig = apiFormTemplatePageGetRequestConfig;

/* prettier-ignore-end */
